var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import ProjectList from './ProjectList';
import { projects } from '../common/siteData';
import theme from '../common/theme';
import useMedia from '../hooks/useMedia';
var StyledMain = styled.main(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  padding: 2rem;\n  width: 100%;\n\n  @media screen and (min-width: ", ") {\n    overflow: auto;\n    height: 100vh;\n  }\n\n  @media screen and (min-width: ", ") {\n  }\n"], ["\n  display: block;\n  padding: 2rem;\n  width: 100%;\n\n  @media screen and (min-width: ", ") {\n    overflow: auto;\n    height: 100vh;\n  }\n\n  @media screen and (min-width: ", ") {\n  }\n"])), theme.breakpoints.s, theme.breakpoints.m);
var StyledMainInner = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  max-width: 1200px;\n"], ["\n  display: block;\n  max-width: 1200px;\n"])));
var Main = function () {
    var mainElem = useRef(null);
    var _a = useState(false), mounted = _a[0], setMounted = _a[1];
    var _b = useState(0), scrollTop = _b[0], setScrollTop = _b[1];
    var isMobile = useMedia("(max-width: ".concat(theme.breakpoints.s, ")"));
    var windowListener = function () {
        setScrollTop(window.pageYOffset);
    };
    var mainListener = function (e) {
        setScrollTop(e.currentTarget.scrollTop);
    };
    useEffect(function () {
        if (!mounted) {
            setMounted(true);
            setScrollTop(mainElem.current.scrollTop);
        }
        if (isMobile) {
            window.addEventListener('scroll', windowListener);
            return function () {
                window.removeEventListener('scroll', windowListener);
            };
        }
        mainElem.current.addEventListener('scroll', mainListener);
        return function () {
            mainElem.current.removeEventListener('scroll', mainListener);
        };
    }, [mounted, isMobile]);
    return (React.createElement(StyledMain, { ref: mainElem },
        React.createElement(StyledMainInner, null,
            React.createElement("h2", null,
                React.createElement("span", null, "Personal Projects")),
            React.createElement(ProjectList, { data: projects.personal, scrollTop: scrollTop }),
            React.createElement("h2", null,
                React.createElement("span", null, "Commercial Work")),
            React.createElement(ProjectList, { data: projects.commercial, scrollTop: scrollTop }))));
};
export default Main;
var templateObject_1, templateObject_2;
